module.exports = __webpack_public_path__ + "img/user-3.c4597102.svg";